export default "__VITE_ASSET__QUueWcG$__"